import './initialize';

import React from 'react';
import { render } from 'react-snapshot';
import {
  Route,
} from 'react-router-dom';
import { Router } from 'react-router';
import firebase from 'firebase';

import appHistory from './history';
// components
import Landing from './entries/Static/Landing';
import App from './entries/App/App';
import Auth from './entries/Auth/Auth';
import Terms from './entries/Legal/Terms';
import Privacy from './entries/Legal/Privacy';
import PrivateRoute from './components/Auth/PrivateRoute';
import registerServiceWorker from './registerServiceWorker';
// stores
import StoreManager from './stores/StoreManager';
// tools
import { LoadingUI, LoadingComponent } from './tools/Loading';
// css
import 'bootstrap/dist/css/bootstrap.css';
// import 'bootstrap/dist/css/bootstrap-theme.css';
import './index.css';
import './tools/ScreenHelper';

LoadingUI.show();
const root = document.getElementById("root");
render(<LoadingComponent />, root);

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    StoreManager
    .initialize(user.uid)
    .then(() => {
      const loc = appHistory.location;
      let path = "/app";
      if (loc.state && loc.state.from) {
        path = loc.state.from;
      }
      appHistory.push(path);
      renderApp();
    })
    .catch(() => appHistory.push("/auth"));
  } else {
    StoreManager.clear();
    renderApp();
  }
});

function renderApp() {
  LoadingUI.hide();
  render(
    <Router history={appHistory}>
      <div className="Index-body">
        <Route exact path="/" component={Landing} />
        <PrivateRoute path="/app" component={App} />
        <Route path="/auth" component={Auth} />
        <Route path="/terms" component={Terms} />
        <Route path="/privacy" component={Privacy} />
        <LoadingComponent />
      </div>
    </Router>, root);
}

registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js